export const metadata = {
  title: "Venue Spotlight: Palacio de los Deportes 🔍",
  date: "2025-05-04",
  excerpt: "A deeper look at the venue hosting the final 8 of the Copa de la Reina",
  slug: "venue-spotlight-palacio-de-los-deportes",
  instagram: "https://www.instagram.com/p/DJFRh0uPNWl",
  instagramCaption:"Timelapse courtesy of the RFEF Futbol Sala Instagram account",
  content: `

A well overdue deepdive into the Palacio de los deportes which has hosted the final 8 of the RFEF's Copa de la Reina futbol sala finals.

Situated in the west of Cartagena the Palacio de los deportes was constructed for a cost of	21.5 million euros! Officially opened on October 7, 2017, and recently remodeled in March 2024, the venue is a key sporting hub in the region. 

The arena features a maximum capacity of 4,825 spectators for futsal and 5,162 for basketball, accommodating press, VIP guests, accessibility seating, and courtside spectators. It serves as the home ground for Jimbee Cartagena and ODILO FC Cartagena CB, which competes in LEB Gold basketball.

From May 2nd to May 4th 2025, the Palacio de los Deportes in Cartagena hosts the final phase of the SM La Reina de Fútbol Sala Cup. A futsal competition that sees the 8 best teams in the country fight for the title.

Perhaps the biggest takeaway from the final is the decision from the RFEF to allow spectators in to watch the final completely free of charge. A key problem prohibiting the growth of the sport, has sadly been raising the barriers to fans before venues are anywhere near their total capacity.

Watch how the RFEF transform the regular court flooring to make way for the bright green Cope de la Reina themed flooring. 

`
};
